export default __webpack_public_path__ + "static/13-min-2a0d1a448c9db5914637755b101b443a.png";